import { Card, CardContent, Tab, Tabs, Box, Typography, Grid, TableContainer, Table, TableBody, TableRow, TableCell, TableHead } from "@mui/material";
import { MailOutline, Home, Person, Send } from "@mui/icons-material";
import styled from "@emotion/styled";
import React, { useEffect, useState } from "react";
import TelefonoListado from "../telefono/TelefonosList";
import apiInstance from "../../../services/ServiceApi";
import AlertModal from "../../utilities/AlertModal";
const StyledCard = styled(Card)`
  max-width: 100%;
  margin: auto;
`;

const Cliente = ({ identificador, lineaNegocio, manejarIdCliente ,campania,codigo_usuario}) => {
  //const { data, loading, error } = useAxiosGeneral('get', 'cliente/detalle', { identificador: identificador, cliente__id_linea_negocio: idLineaNegocio });
  const [data, setData] = useState([]);
  const [error, setError] = useState(false);
  const [value, setValue] = useState(0);
  const [tabs, setTabs] = useState({ correo: false, direccion: false, accionista_funcionario: false });
  const tabsArray = [
    { name: "Datos", icon: <Person />, dataKey: null, condition: true },
    { name: "Correos", icon: <MailOutline />, dataKey: "correo", condition: data?.correo?.length > 0 },
    { name: "Direcciones", icon: <Home />, dataKey: "direccion", condition: data?.direccion?.length > 0 },
    { name: "Accionistas/Funcionarios", icon: <Person />, dataKey: "accionista_funcionario", condition: data?.accionista_funcionario?.length > 0 },
    { name: "SMS", icon: <Send />, dataKey: "sms", condition: data?.sms?.length > 0 },
  ];
  console.log("mostrar",identificador, lineaNegocio)
  const tabsFiltered = tabsArray.filter(tab => tab.condition);
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiInstance.get('cliente/', { params: { identificador: identificador, linea_negocio: lineaNegocio.id }});
        console.log(response)
        setData(response.data); 
        setError(false);

      } catch (error) {
        setError(true);
        console.log(error)

      }
    };
    
    fetchData();
  }, [identificador, lineaNegocio]); 
  
  
  useEffect(() => {
    if (data.cliente) {
      manejarIdCliente(data.cliente.id);
    } else if (error) {
      manejarIdCliente(false);
    }
    else{
      manejarIdCliente(false);
    }
  }, [data, error]);

  
  useEffect(() => {
    if (data) {
      setTabs({
        correo: data.correo && data.correo.length > 0,
        direccion: data.direccion && data.direccion.length > 0,
        accionista_funcionario: data.accionista_funcionario && data.accionista_funcionario.length > 0,
      });
    }
  }, [data]);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  
  return (
    <Grid container spacing={2} mb={5}>
      <Grid item xs={12} md={9}>
        <StyledCard>
          <Tabs value={value} onChange={handleChange} variant="scrollable" scrollButtons="auto">
            {tabsFiltered.map((tab, index) => (
              <Tab key={index} icon={tab.icon} label={tab.name} />
            ))}
          </Tabs>
          <CardContent>
            {tabsFiltered.map((tab, index) => (
              <TabPanel key={index} value={value} index={index}>
                {tab.dataKey && data[tab.dataKey] && data[tab.dataKey].length > 0 ? (
                  <TableContainer>
                    <Table>
                      <TableHead>
                        <TableRow>
                          {Object.keys(data[tab.dataKey][0]).map((key, i) => (
                            <TableCell key={i}>{key}</TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {data[tab.dataKey].map((item, i) => (
                          <TableRow key={i}>
                            {Object.values(item).map((value, j) => (
                              <TableCell key={j}>{value}</TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                    ) : (
                        data.cliente  && (
                        <>
                          <Typography variant="body1">Identificador: {data.cliente.identificador}</Typography>
                          <Typography variant="body1">
                            Nombres: {
                              data.cliente.nombre_completo ? 
                              data.cliente.nombre_completo : 
                              `${data.cliente.nombre} ${data.cliente.apellido_paterno}${data.cliente.apellido_materno ? ` ${data.cliente.apellido_materno}` : ''}`
                            }
                          </Typography>

                          <Typography variant="body1">N. Documento: {data.cliente.numero_documento}</Typography>
                          <Typography variant="body1">Edad: {data.cliente.edad}</Typography>
                          <Typography variant="body1">CAMPAÑA: {campania}</Typography>
                          {lineaNegocio.id === 4 && lineaNegocio.fecha_carga && (
                                      <Typography variant="body1">Fecha Carga: {lineaNegocio.fecha_carga}</Typography>
                                    )}

                        </>   
                      ))
                  }
                  </TabPanel>
                        ))}
          </CardContent>
        </StyledCard>
      </Grid>
      <Grid item xs={12} md={3}>
        {data.cliente && (
          <TelefonoListado telefonos={data.telefono} codigo_usuario={codigo_usuario} cliente_id={data.cliente.id} lineaNegocio={lineaNegocio} />
        )
        }
      </Grid>
    </Grid>
  );
                    
  };

function TabPanel({ children, value, index }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

export default Cliente;